import React from 'react';
import { OutboundLink } from 'gatsby-plugin-google-analytics';

function Randomizer(props) {
  const millsAds = [
    {
      image: '/snow-white-2023/ads/barr-aesthetics.jpg',
      link: 'https://www.barraesthetics.com/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=balletwest',
      alt: 'Barr Aesthetics',
      class: 'webFormat',
    },
    {
      image: '/snow-white-2023/ads/blue-iguana.jpg',
      link: 'https://blueiguanarestaurant.net/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=balletwest',
      alt: 'Blue Iguana',
      class: 'webFormat',
    },
    {
      image: '/snow-white-2023/ads/daynes-music.jpg',
      link: 'http://www.daynesmusic.com/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=balletwest',
      alt: 'Daynes Music',
      class: 'webFormat',
    },
    {
      image: '/snow-white-2023/ads/afcu.jpg',
      link: 'https://www.americafirst.com/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=balletwest',
      alt: 'America First Credit Union',
      class: 'webFormat',
    },
    {
      image: '/snow-white-2023/ads/amg.jpg',
      link: 'https://www.amgseniormedical.com/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=balletwest',
      alt: 'AMG Senior Medical Group',
      class: 'webFormat',
    },
    {
      image: '/snow-white-2023/ads/tuacahn.jpg',
      link: 'https://www.tuacahn.org/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=balletwest',
      alt: 'Tuacahn Amphitheatre',
      class: 'webFormat',
    },
    {
      image: '/snow-white-2023/ads/pbs.jpg',
      link: 'https://pbsutah.org/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=balletwest',
      alt: 'Sugar House Furniture and The Madeleine Choir School',
      class: 'webFormat',
    },
    {
      image: '/snow-white-2023/ads/bmw-murray.jpg',
      link: 'https://www.bmwutah.com/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=balletwest',
      alt: 'BMW of Utah',
      class: 'webFormat',
    },
    {
      image: '/snow-white-2023/ads/country-hill-eye-center.jpg',
      link: 'https://www.checdocs.org/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=balletwest',
      alt: 'Country Hills Eye Center',
      class: 'webFormat',
    },
    {
      image: '/snow-white-2023/ads/classical89.jpg',
      link: 'https://www.classical89.org/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=balletwest',
      alt: 'Classical 89',
      class: 'webFormat',
    },
    {
      image: '/snow-white-2023/ads/challenger.jpg',
      link: 'https://www.challengerschool.com/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=balletwest',
      alt: 'Challenger School',
      class: 'webFormat',
    },
    {
      image: '/snow-white-2023/ads/hamilton-park.jpg',
      link: 'https://www.hamiltonparkinteriors.com/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=balletwest',
      alt: 'Hamilton Park Interiors',
      class: 'webFormat',
    },
    {
      image: '/snow-white-2023/ads/minky-couture.jpg',
      link: 'http://www.minkycouture.com/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=balletwest',
      alt: 'Minky Couture',
      class: 'webFormat',
    },
    {
      image: '/snow-white-2023/ads/usf.jpg',
      link: 'https://www.bard.org/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=balletwest',
      alt: 'Utah Shakespeare Festival',
      class: 'webFormat',
    },
    {
      image: '/snow-white-2023/ads/rc-willey.jpg',
      link: 'https://www.rcwilley.com/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=balletwest',
      alt: 'RC Willey',
      class: 'webFormat',
    },
    {
      image: '/snow-white-2023/ads/regency-royale.png',
      link: 'http://www.regencyroyale.com/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=balletwest',
      alt: 'Regency Royal',
      class: 'webFormat',
    },
    {
      image: '/snow-white-2023/ads/ufo.jpg',
      link: 'https://www.utahfestival.org/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=balletwest',
      alt: 'Utah Festival Opera',
      class: 'webFormat',
    },
    {
      image: '/snow-white-2023/ads/u-first-credit.jpg',
      link: 'https://www.ufirstcu.com/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=balletwest',
      alt: 'U First Credit Union',
      class: 'webFormat',
    },
    {
      image: '/snow-white-2023/ads/utah-school-dance.jpg',
      link: 'https://tickets.utah.edu/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=balletwest',
      alt: 'University of Utah Dance',
      class: 'webFormat',
    },
    {
      image: '/snow-white-2023/ads/adibs.jpg',
      link: 'https://adibs.com/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=balletwest',
      alt: 'Adib’s Rug Gallery',
      class: 'webFormat',
    },
  ];

  const [randomAd] = React.useState(
    millsAds[Math.floor(Math.random() * millsAds.length)]
  );

  return (
    <>
      <br />
      <OutboundLink
        href={randomAd.link}
        target="_blank"
        rel="noopener noreferrer"
      >
        <img
          src={randomAd.image}
          alt={randomAd.alt}
          className={randomAd.class}
        />
      </OutboundLink>
      <br />
      <br />
      <hr />
      <br />
    </>
  );
}

export default Randomizer;
